import { getProfilePic } from "../../utils/apiFunctions";

export const LogoutMixins = {
  methods: {
    logout() {
      localStorage.clear();
      this.$store.dispatch("userVUEX/LogOut");
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      location.reload();
    },
    async getUsericon() {
      let generatedName = this.extPanel.charAt(0);

      const userImage = await getProfilePic(generatedName);
      if (userImage.status == 200) {
        this.profileIcon = userImage.data.data.link;
      }
    },
  },
};
